export const selfBlocksSelector = (state) => state.clients.sourcesWithPriority;
